import { useLLMConversations } from '@ltvco/refresh-lib/hooks';
import { Box } from '@ltvco/refresh-lib/theme';
import { useNavigate, useParams } from 'react-router-dom';

import { formatText } from 'components/ChatBV/utils';

import { StyledConversationList } from './components';
import { ConversationItem } from './ConversationItem';
import { ConversationListSkeleton } from './ConversationListSkeleton';

export const ConversationList = ({
  collapsed,
  fullWidth: _fullWidth,
  onConversationClick,
}: {
  collapsed: boolean;
  fullWidth?: boolean;
  onConversationClick?: () => void;
}) => {
  const { conversationsQuery } = useLLMConversations();
  const params = useParams();
  const currentContextId = params.context_id || params.contextId;

  const chatList = conversationsQuery.data?.conversations;
  const isLoading = conversationsQuery.isLoading;
  const navigate = useNavigate();

  const handleConversationClick = (context_id: string) => {
    navigate(`/chatbv/chat/conversation/${context_id}`);
    onConversationClick?.();
  };

  if (isLoading) {
    return (
      <StyledConversationList collapsed={collapsed} alignItems="flex-start">
        <ConversationListSkeleton />
      </StyledConversationList>
    );
  }

  return (
    <StyledConversationList collapsed={collapsed} alignItems="flex-start">
      <Box sx={{}}>
        {chatList?.map((conversation) => {
          const isActive = conversation.context_id === currentContextId;
          const title = formatText(
            conversation.conversation_title ?? 'Start of a new conversation'
          );
          return (
            <ConversationItem
              key={conversation.context_id}
              title={title}
              isActive={isActive}
              onClick={() => handleConversationClick(conversation.context_id)}
            />
          );
        })}
      </Box>
    </StyledConversationList>
  );
};
